define(function (require) {
    "use strict";

    var LE = require("app");

    var SkillsListFilters = [];

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {
        SkillsListFilters = [
            {
                name: "name",
                type: Marionette.GridView.FILTERS.TYPES.MULTISELECT,

                getFilterData: function () {
                    var dataManager = LEUserManagement.getDataManager();
                    var skillsCollection = dataManager.getData(dataManager.getEntities().SKILL);
                    var hasEntitiesTaggingByLobFeature = LE.sessionManager.hasEntitiesTaggingByLobFeature();

                    var valuesArr = [];
                    skillsCollection.each(function (skillModel) {
                        var skillLobs = skillModel.getLobs();
                        var skillAllowed = LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.isLobAllowedForUser, skillLobs);
                        if (!hasEntitiesTaggingByLobFeature || skillAllowed) {
                            valuesArr.push({id: skillModel.getName(), value: skillModel.getName()});
                        }
                    });
                    return {
                        valuesArr: valuesArr,
                        placeholderText: LE.translator.translate("LEUserManagement.skillList.column.name.filter.placeholder")
                    };
                }
            },
            {
                name: "lobs",
                type: Marionette.GridView.FILTERS.TYPES.MULTISELECT,

                getFilterData: function (options) {
                    var gridModel = options.gridModel;
                    var allowedLobs = LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.getAllowedLobs);
                    var isAllLobsAllowedForUser = LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.isAllLobsAllowedForUser);

                    var valuesArr = [];

                    _.each(allowedLobs, function (lobModel) {
                        valuesArr.push({id: lobModel.id, value: lobModel.getName()});
                    });

                    if (isAllLobsAllowedForUser) {
                        valuesArr.push({id: gridModel.NO_LOBS_VALUE, value:LE.translator.translate("LEUserManagement.skillList.column.lobs.filter.noLobs")});
                    }


                    return {valuesArr: valuesArr, placeholderText: LE.translator.translate("LEUserManagement.skillList.column.lobs.filter.placeholder")};
                }
            }
        ];
    }

    LE.module("LEUserManagement", moduleDefinition);

    return SkillsListFilters;
});
